import { NormalizeOAS, OASRequestParams, OASResponse } from 'fets';
import type assetLibraryOpenApi from '../asset-library-open-api';
import { AssetLibraryFetsApiClient } from '../asset-library-fets-client';
import { assertNever } from '../utils';
import { Guid } from '../../api/public/utils/Guid';

const PATH = '/api/v2/asset-directory-tree/company/{companyId}/{directoryId}/archive';

type Params = {
  companyId: Guid;
  directoryId: Guid;
};

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<void>;

export const createArchiveAssetDirectory = (apiClient: AssetLibraryFetsApiClient): ApiFunction => {
  const archiveAssetDirectory = async (params: Params, signal?: AbortSignal): Promise<void> => {
    const response = await apiClient[PATH].post({
      ...convertToRequest(params),
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return archiveAssetDirectory;
};

type Request = OASRequestParams<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'post'>;
type Response = OASResponse<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'post'>;

const convertToRequest = (params: Params): Request => ({
  params: { companyId: params.companyId, directoryId: params.directoryId },
});

const convertResponse = async (response: Response): Promise<void> => {
  const responseStatus = response.status;
  if (responseStatus !== 204) {
    return assertNever(responseStatus);
  }
};
